import profile from "./user/profile";
import address from "./user/address";
import cart from "./user/cart";
import orders from "./user/orders";
import quiz from "./user/quiz";
import constraints from "./user/constraints";
import surveys from "./user/surveys";
import checkout from "./user/checkout";
import catalog from "./user/catalog";
import approval from "./user/approval";
import permissions from "./user/permissions";
import {platform} from "@/api/platform";
import {order} from "@/api/order";
import {delivery} from "@/api/delivery";
import {retryRequest} from "@/helpers/request";
import {PERMISSIONS} from "@/constants";

export default {
    namespaced: true,
    state: {
        token: null,
        id: null,
        stylistTags: null,
        language: null,
        acknowledgement: null,
        requireAcknowledgement: null,
        loaded: false
    },
    getters: {
        isAuthenticated: state => !!state.token,
        id: state => state.id,
        token: state => state.token,
        stylistTags: state => state.stylistTags,
        language: state => state.language,
        acknowledgement: state => state.acknowledgement,
        requireAcknowledgement: state => state.requireAcknowledgement,
        loaded: state => state.loaded
    },
    mutations: {
        setToken: (state, token) => state.token = token,
        setId: (state, id) => state.id = id,
        setStylistTags: (state, stylistTags) => state.stylistTags = stylistTags,
        setLanguage: (state, language) => state.language = language,
        setAcknowledgement: (state, acknowledgement) => state.acknowledgement = acknowledgement,
        setRequireAcknowledgement: (state, requireAcknowledgement) => state.requireAcknowledgement = requireAcknowledgement,
        setLoaded: (state, loaded) => state.loaded = loaded
    },
    actions: {
        fetch(context, data) {

            if (data) {

                context.commit("setToken", data.token);
                context.commit("setId", data.id);
                context.commit("setStylistTags", data.stylistTags);
                context.commit("setRequireAcknowledgement", data.requireAcknowledgement)

                this.dispatch("user/permissions/setPermissions", data.permissions.permissions);
                this.dispatch("user/permissions/setRestrictions", data.permissions.restrictions);
            }

            platform.disableUnauthorizedInterceptor();
            order.disableUnauthorizedInterceptor();
            delivery.disableUnauthorizedInterceptor();

            const promises = [
                retryRequest(() => platform.get(`/api/v2/consumers/${context.state.id}`, {params: {get: "preferred_language,acknowledgement"}})),
                this.dispatch("user/profile/fetch"),
                this.dispatch("user/surveys/fetch"),
                this.dispatch("user/checkout/fetch"),
                this.dispatch("user/approval/fetch")
            ];

            return Promise.all(promises)
                .then(responses => {

                    const [consumerResponse] = responses;
                    const language = consumerResponse.data.results.preferred_language;
                    const acknowledgement = consumerResponse.data.results.acknowledgement;

                    context.commit("setLanguage", language);
                    context.commit("setAcknowledgement", acknowledgement);
                    context.commit("setLoaded", true);

                    const promises = [
                        this.dispatch("i18n/fetch")
                    ];

                    if (this.getters["user/profile/country"] && this.getters["user/profile/equipment_submitted"]) {

                        promises.push(this.dispatch("user/cart/fetch"));

                        if (this.getters["user/permissions/hasPermission"](PERMISSIONS.EMPLOYEE)) {

                            promises.push(this.dispatch("user/constraints/fetch"));
                        }
                    }

                    return Promise.all(promises).then(responses => {

                        if (language) {

                            this.dispatch("i18n/setLanguage", this.getters["i18n/languages"].find(l => l.value == language));
                        }
                    });
                })
                .finally(() => {

                    platform.enableUnauthorizedInterceptor();
                    order.enableUnauthorizedInterceptor();
                    delivery.enableUnauthorizedInterceptor();
                })
        },
        setLanguage(context, language) {

            context.commit("setLanguage", language);

            if (context.getters["isAuthenticated"]) {

                return platform.put(`/api/v2/consumers/${context.state.id}`, {preferred_language: language});
            }
        },
        setAcknowledgement(context, acknowledgement) {

            context.commit("setAcknowledgement", acknowledgement);

            return platform.put(`/api/v2/consumers/${context.state.id}`, {acknowledgement});
        },
        logout(context, reason) {

            platform.post(`/api/v2/users/${context.state.id}/jwt/logout`);

            context.commit("setId", null);
            context.commit("setToken", null);
            context.commit("setStylistTags", null);
            context.commit("setLanguage", null);

            if (401 !== reason) {

                this.dispatch("user/quiz/equipment/clear");
            }

            this.dispatch("user/profile/clear");
            this.dispatch("user/address/clear");
            this.dispatch("user/cart/clear");
            this.dispatch("user/constraints/clear");
            this.dispatch("user/quiz/profile/clear");
            this.dispatch("user/surveys/clear");
            this.dispatch("user/checkout/clear");
            this.dispatch("user/approval/clear");
            this.dispatch("user/permissions/clear");
        }
    },
    modules: {
        profile,
        address,
        cart,
        orders,
        quiz,
        constraints,
        surveys,
        checkout,
        approval,
        permissions,
        catalog,
    }
}